export class Controller {

    /** @ngInject */
    constructor(LicenseManagementService, Alert, $stateParams) {
        this.LicenseManagementService = LicenseManagementService;
        this.Alert = Alert;
        this.$stateParams = $stateParams;
    }
 
    $onInit() {
    }

    $onChanges() {
    }

    saveEmail(email) {
        this.LicenseManagementService.changeLicenseEmail(this.$stateParams.companyId, email)
            .then(()=> {
                this.Alert('success', 'global.messages.operation-successful');
                this.currentPlan.licensingActivitiesEmailAddress = email;
            })
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/current-plan/subscription-info/subscription-info.controller.js